//注册产品组件
export function registerProductComponents(Vue) {
    const requireProductComponent = require.context(
        // 其组件目录的相对路径
        '@/components/product',
        // 是否搜索子目录
        true,
        // 匹配基本名称的正则表达式
        /[\w-]+\.vue$/
    );
    requireProductComponent.keys().forEach((fileName) => {
        // 获取组件配置
        const componentConfig = requireProductComponent(fileName);

        // 获取组件的基本名称
        const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '');

        // 全局注册组件
        Vue.component(componentName, componentConfig.default || componentConfig);
    });
}
//注册订单组件
export function registerOrderComponents(Vue) {
    const requireProductComponent = require.context(
        // 其组件目录的相对路径
        '@/components/order',
        // 是否搜索子目录
        true,
        // 匹配基本名称的正则表达式
        /[\w-]+\.vue$/
    );
    requireProductComponent.keys().forEach((fileName) => {
        // 获取组件配置
        const componentConfig = requireProductComponent(fileName);

        // 获取组件的基本名称
        const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '');

        // 全局注册组件
        Vue.component(componentName, componentConfig.default || componentConfig);
    });
}

//注册门店组件
export function registerStoreComponents(Vue) {
    const requireProductComponent = require.context(
        // 其组件目录的相对路径
        '@/components/store',
        // 是否搜索子目录
        true,
        // 匹配基本名称的正则表达式
        /[\w-]+\.vue$/
    );
    requireProductComponent.keys().forEach((fileName) => {
        // 获取组件配置
        const componentConfig = requireProductComponent(fileName);

        // 获取组件的基本名称
        const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '');

        // 全局注册组件
        Vue.component(componentName, componentConfig.default || componentConfig);
    });
}
